/**
 * Значение поля ratio у элемента картинки по умолчанию
 * @type {Number}
 */
export var DEFAULT_IMAGE_RATIO = 1;

/**
 * Значение стандартного соотношения сторон для
 * картинки во всю ширину карточки
 * @type {Number}
 */
export var DEFAULT_FULLSIZE_RATIO = 1;

/**
 * Цвет кнопки по умолчанию
 * @type {String}
 */
export var DEFAULT_BUTTON_BACKGROUND_COLOR = '#edf0f2';

/**
 * Цвет разделителя по умолчанию
 * @type {String}
 */
export var DEFAULT_DELIMITER_COLOR = 'rgba(0, 0, 0, 0.2)';

/**
 * Цвет круга трафика по умолчанию
 * @type {String}
 */
export var DEFAULT_TRAFFIC_COLOR = '#edf0f2';

/**
 * Типы блоков
 * @type {Object}
 */
export var BLOCK = {
  image: 'div-image-block',
  buttons: 'div-buttons-block',
  traffic: 'div-traffic-block',
  footer: 'div-footer-block',
  table: 'div-table-block',
  separator: 'div-separator-block',
  universal: 'div-universal-block',
  title: 'div-title-block',
  container: 'div-container-block',
  tabs: 'div-tabs-block',
  gallery: 'div-gallery-block'
};

/**
 * Типы элементов
 * @type {Object}
 */
export var ELEMENT = {
  image: 'div-image-element',
  button: 'div-button-element',
  separator: 'separator_element',
  row: 'row_element',
  date: 'date_element'
};

/**
 * Идентификатор состояния дива по умолчанию
 * @type {Number}
 */
export var DEFAULT_DIV_STATE_ID = 1;

/**
 * Цвета элементов таба по умолчанию
 * @type {Object}
 */
export var TABS_COLOR = {
  inactiveTab: 'rgba(0, 0, 0, 0.5)',
  activeTab: 'rgba(0, 0, 0, 0.8)',
  activeTabBg: '#FFDC60',
  delimiter: 'rgba(0, 0, 0, 0.08)'
};

/**
 * Паддинги элементов галереи по умолчанию
 * @type {Object}
 */
export var GALLERY_DEFAULT_PADDINGS = {
  between: 8
};

/**
 * Цвета иконки хвоста в галерии
 * @type {Object}
 */
export var TAIL_ICON_COLOR = {
  icon: '#808080',
  border: '#F2F2F2',
  fill: '#F2F2F2'
};